import React from "react";
import {TimeField} from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";


const StyledTimeField = ({disabled,label, format, valueField, color, borderColor, backgroundColor, onChange, onKeyDown = () => {} }) => {
    // helper: secondi → dayjs
    const secondsToDayjs = (s)  =>
        dayjs().startOf("day").add(s, "second");

    // helper: dayjs → secondi
    const dayjsToSeconds = (d)  =>
        d.diff(d.startOf("day"), "second");

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimeField
                disabled={disabled}
                label={label}
                value={secondsToDayjs(valueField)}
                onChange={(newValue) => {
                    if (newValue) {
                        onChange(dayjsToSeconds(newValue));
                    }
                }}
                onKeyDown={onKeyDown}
                format={format}
                sx={{
                // Stili per variabili generali (colore normale)
                backgroundColor: backgroundColor,
                color: color, // Colore di base per il componente

                // Stili per il testo dell'input
                "& .MuiInputBase-input": {
                    color: color, // Colore normale
                    "&.Mui-disabled": {
                        color: `grey !important`, // Fallback per altri browser
                        "-webkit-text-fill-color": `grey !important`, // Override per Chrome/Safari
                    },
                },

                // Stili per l'etichetta (Label)
                "& .MuiInputLabel-root": {
                    color: color, // Etichetta normale
                    "&.Mui-focused": {
                        color: color, // Etichetta in focus
                    },
                    "&.Mui-disabled": {
                        color: `grey !important`, // Etichetta disabilitata (di solito 'color' qui basta)
                    },
                },

                // Stili per il bordo (OutlinedInput)
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: borderColor, // Bordo normale
                    },
                    "&:hover fieldset": {
                        borderColor: borderColor, // Bordo hover
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: borderColor, // Bordo focus
                    },
                    // Bordo rosso quando disabilitato (come nel tuo codice originale)
                    "&.Mui-disabled fieldset": {
                        borderColor: `grey !important`,
                    },
                },
            }}
            />

        </LocalizationProvider>




    )

}

export default StyledTimeField;